import request from '@/utils/request'

// /index/list/check/web 核查网站列表
export function listWeb() {
  return request({
    url: '/index/list/check/web',
    method: 'get'
  })
}
// index/list/league/company 联盟单位列表
export function listLeague() {
  return request({
    url: '/index/list/league/company',
    method: 'get'
  })
}
export function detailLeague(id) {
  return request({
    url: '/index/detail/league/company?id=' + id,
    method: 'get'
  })
}
// /index/list/source/company 信源单位列表
export function listSource() {
  return request({
    url: '/index/list/source/company',
    method: 'get'
  })
}
export function detailSource(id) {
  return request({
    url: '/index/detail/source/company?id=' + id,
    method: 'get'
  })
}
export function indexSearch(keywords) {
  return request({
    url: '/index/report/detail?keywords=' + keywords,
    method: 'get'
  })
}


// credit/list/catalogue 信用自测-目录列表
export function catalogue() {
  return request({
    url: '/credit/list/catalogue',
    method: 'get'
  })
}
// credit/list/examine 信用自测-答题列表
export function examine() {
  return request({
    url: '/credit/list/examine',
    method: 'get'
  })
}


// credit/save/draft 信用自测-保存草稿
export function saveDraft(data) {
  return request({
    url: '/credit/save/draft',
    method: 'post',
    data
  })
}
// credit/report/export 报告下载
export function reportDownload(id) {
  return request({
    url: '/credit/report/export?id=' + id,
    method: 'get'
  })
}



// credit/commit/examine 信用自测-提交评分
export function commitExamine(data) {
  return request({
    url: '/credit/commit/examine',
    method: 'post',
    data
  })
}



// /dev-api/api/credit/report/list  报告列表查询
export function reportList() {
  return request({
    url: '/credit/report/list',
    method: 'get'
  })
}
// 报告详情
export function reportDetail(id) {
  return request({
    url: '/credit/report/detail?id=' + id,
    method: 'get'
  })
}

// 信用自测-获取基础信息类型
export function testBase() {
  return request({
    url: '/credit/base/info',
    method: 'get'
  })
}

// 信用自测-提交基础信息
export function testBaseSubmit(data) {
  return request({
    url: '/credit/base/info/save',
    method: 'post',
    data
  })
}

// 数据报送
export function dataSendDetail() {
  return request({
    url: '/index/website/serve?id=4',
    method: 'get'
  })
}

// 删除报告
export function delReport(data) {
  return request({
    url: '/credit/report/delete',
    method: 'post',
    data
  })
}

export function getServeInfo() {
  return request({
    url: '/index/serve/number',
    method: 'get'
  })
}

export function getUserType() {
  return request({
    url: '/index/get/userType',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js